import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  Sheet,
  SheetBody,
  SheetContent,
  Typography,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import routes from "routes"

import LearningPageImg from "./assets/learning-page.webp"

const Content = ({
  onClickLater,
  onClickAssessment,
}: {
  onClickLater: () => void
  onClickAssessment: () => void
}) => {
  return (
    <div>
      <div className="grid h-[180px] place-items-center overflow-hidden bg-[linear-gradient(180deg,#D1F1FF_0%,#FFFFFF_100%)]">
        <img
          src={LearningPageImg}
          className="h-full max-h-[180px] object-contain"
          alt="learning-page"
        />
      </div>
      <div className="p-3">
        <Typography variant="title2" className="mb-1.5">
          Before you start learning…
        </Typography>
        <Typography className="mb-1.5 text-lg font-medium leading-[130%] tracking-[-2%] text-onSurface-500">
          We strongly recommend you complete your CPAT Skill Analysis.
        </Typography>
        <Typography className="mb-5 text-onSurface-500">
          It is a <strong>one-hour assessment (50 questions)</strong> that gives
          you the power to officially measure and validate your existing
          teaching skills.
        </Typography>
        <div className="flex items-center justify-end gap-1.5">
          <Button
            onClick={onClickLater}
            className="bg-[#F7F8F8] text-[#3B3D46]"
            autoFocus={false}
          >
            Maybe Later
          </Button>
          <Button onClick={onClickAssessment} color="black" autoFocus>
            Take Assessment
          </Button>
        </div>
      </div>
    </div>
  )
}
const BeforeYouStart = ({
  open,
  handleClose,
}: {
  open: boolean
  handleClose: () => void
}) => {
  const isSmDown = useMediaQuery("only screen and (max-width : 599px)")
  const [isOpen, setIsOpen] = useState(open)
  const navigate = useNavigate()

  useEffect(() => {
    setIsOpen(open)
  }, [open])

  const handleCloseLocal = () => {
    setIsOpen(false)
    handleClose()
  }

  const onClickAssessment = () => {
    navigate(routes.cpat.dashboard)
    handleCloseLocal()
  }

  if (isSmDown) {
    return (
      <Sheet open={isOpen}>
        <SheetContent height={78} className="!p-0">
          <SheetBody className="rounded-t-2xl !p-0">
            <Content
              onClickAssessment={onClickAssessment}
              onClickLater={handleCloseLocal}
            />
          </SheetBody>
        </SheetContent>
      </Sheet>
    )
  }
  return (
    <Dialog open={isOpen} onOpenChange={handleCloseLocal}>
      <DialogContent className="overflow-hidden rounded-2xl  p-0">
        <DialogBody className="p-0">
          <Content
            onClickAssessment={onClickAssessment}
            onClickLater={handleCloseLocal}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default BeforeYouStart
